import Icon from '@ant-design/icons/lib/components/Icon';
import * as React from 'react';
const IHide = (props: any) => {
  return (
    <Icon
      component={() => {
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="28"
            height="26"
            viewBox="0 0 28 26"
            fill={props.color ?? '#37474F'}
          >
            <g clipPath="url(#clip0_63_3841)" filter="url(#filter0_d_63_3841)">
              <path
                d="M20.3367 2.13477L17.5483 4.74893C16.49 4.39227 15.31 4.16643 14.0125 4.16643C7.705 4.16643 4 9.6256 4 9.6256C4 9.6256 5.60667 12.0848 8.28833 13.9073L5.8625 16.3314L7.04083 17.5098L21.5158 3.31393L20.3367 2.13477ZM15.3233 6.9506C12.5833 5.73977 9.75583 8.5406 10.9358 11.2889L9.4975 12.7114C7.98583 11.7448 6.81 10.5031 6.11417 9.66143C7.35833 8.2881 10.1283 5.8331 14.0125 5.8331C14.785 5.8331 15.5092 5.93227 16.1875 6.0956L15.3233 6.9506ZM12.9208 13.1431L17.1625 8.98227C18.01 11.5748 15.4933 14.0381 12.9208 13.1431ZM24 9.6256C24 9.6256 20.4567 15.8331 14.0125 15.8331C12.8633 15.8331 11.7942 15.5906 10.8033 15.2189L12.1483 13.8998C12.7442 14.0606 13.3633 14.1664 14.0125 14.1664C18.005 14.1664 20.7658 11.2273 21.9325 9.69643C21.325 9.01143 20.3025 8.0381 18.9433 7.23643L20.1842 6.01977C22.6692 7.6031 24 9.6256 24 9.6256Z"
                fill={props.color ?? '#37474F'}
              />
            </g>
            <defs>
              <filter
                id="filter0_d_63_3841"
                x="0"
                y="0"
                width="28"
                height="28"
                filterUnits="userSpaceOnUse"
                colorInterpolationFilters="sRGB"
              >
                <feFlood floodOpacity="0" result="BackgroundImageFix" />
                <feColorMatrix
                  in="SourceAlpha"
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  result="hardAlpha"
                />
                <feOffset dy="4" />
                <feGaussianBlur stdDeviation="2" />
                <feComposite in2="hardAlpha" operator="out" />
                <feColorMatrix
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
                />
                <feBlend
                  mode="normal"
                  in2="BackgroundImageFix"
                  result="effect1_dropShadow_63_3841"
                />
                <feBlend
                  mode="normal"
                  in="SourceGraphic"
                  in2="effect1_dropShadow_63_3841"
                  result="shape"
                />
              </filter>
              <clipPath id="clip0_63_3841">
                <rect
                  width="20"
                  height="20"
                  fill="white"
                  transform="translate(4)"
                />
              </clipPath>
            </defs>
          </svg>
        );
      }}
      {...props}
    />
  );
};

export default IHide;
